import { Component, OnChanges,Input } from '@angular/core';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';
import { PoleStockReview, PSRToken, PolePart } from '../../shared/misc-classes';

@Component({
  selector: 'app-pole-stk-revw',
  templateUrl: './pole-stk-revw.component.html',
  styleUrls: ['./pole-stk-revw.component.css']
})
export class PoleStkRevwComponent implements OnChanges {
  @Input() currMonthDtObj:Date;
  @Input() poleStkRvw:PoleStockReview;   

  constructor(private _dataService:DataService) { }

  ngOnChanges() {
  }
  getProductName(_prodId:string):string{
    if(_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }
  getData(option){
    if(option) return option
    return ''
  }
  getPoleDescPartNo(_pid:string,_id:string):string{
    if(_id) return this._dataService.getPoleDescPartNo(_pid,_id)
    return ''
  }

}
